export const FETCH_APPLICATION_SETTINGS_FLAGS = 'FETCH_APPLICATION_SETTINGS_FLAGS';
export const FETCH_APPLICATION_SETTINGS_FLAGS_SUCCESS = 'FETCH_APPLICATION_SETTINGS_FLAGS_SUCCESS';
export const FETCH_APPLICATION_SETTINGS_FLAGS_FAILURE = 'FETCH_APPLICATION_SETTINGS_FLAGS_FAILURE';
export const UPDATE_APPLICATION_SETTINGS_FLAGS = 'UPDATE_APPLICATION_SETTINGS_FLAGS';
export const UPDATE_APPLICATION_SETTINGS_FLAGS_SUCCESS = 'UPDATE_APPLICATION_SETTINGS_FLAGS_SUCCESS';
export const UPDATE_APPLICATION_SETTINGS_FLAGS_FAILURE = 'UPDATE_APPLICATION_SETTINGS_FLAGS_FAILURE';
export const CLEAR_DEV_CACHE = 'CLEAR_DEV_CACHE';
export const CLEAR_DEV_CACHE_SUCCESS = 'CLEAR_DEV_CACHE_SUCCESS';
export const CLEAR_DEV_CACHE_FAILURE = 'CLEAR_DEV_CACHE_FAILURE';
export const MATERIALIZED_VIEW_REFRESH = 'MATERIALIZED_VIEW_REFRESH';
export const MATERIALIZED_VIEW_REFRESH_SUCCESS = 'MATERIALIZED_VIEW_REFRESH_SUCCESS';
export const MATERIALIZED_VIEW_REFRESH_FAILURE = 'MATERIALIZED_VIEW_REFRESH_FAILURE';
export const UNLOCK_ALL_TAX_ENTRIES = 'UNLOCK_ALL_TAX_ENTRIES';
export const UNLOCK_ALL_TAX_ENTRIES_SUCCESS = 'UNLOCK_ALL_TAX_ENTRIES_SUCCESS';
export const UNLOCK_ALL_TAX_ENTRIES_FAILURE = 'UNLOCK_ALL_TAX_ENTRIES_FAILURE';
export const FETCH_ADMIN_JOBS = 'FETCH_ADMIN_JOBS';
export const FETCH_ADMIN_JOBS_SUCCESS = 'FETCH_ADMIN_JOBS_SUCCESS';
export const FETCH_ADMIN_JOBS_FAILURE = 'FETCH_ADMIN_JOBS_FAILURE';
export const RUN_ADMIN_JOB = 'RUN_ADMIN_JOB';
export const RUN_ADMIN_JOB_SUCCESS = 'RUN_ADMIN_JOB_SUCCESS';
export const RUN_ADMIN_JOB_FAILURE = 'RUN_ADMIN_JOB_FAILURE';
export const RUN_DEACTIVATE_USERS_JOB = 'RUN_DEACTIVATE_USERS_JOB';
export const RUN_DEACTIVATE_USERS_JOB_SUCCESS = 'RUN_DEACTIVATE_USERS_JOB_SUCCESS';
export const RUN_DEACTIVATE_USERS_JOB_FAILURE = 'RUN_DEACTIVATE_USERS_JOB_FAILURE';
export const CLEAR_BSM_BALANCES = 'CLEAR_BSM_BALANCES';
export const CLEAR_BSM_BALANCES_SUCCESS = 'CLEAR_BSM_BALANCES_SUCCESS';
export const CLEAR_BSM_BALANCES_FAILURE = 'CLEAR_BSM_BALANCES_FAILURE';
export const SELECT_PERIODS = 'SELECT_PERIODS';
export const SELECT_COMPANY_CODES = 'SELECT_COMPANY_CODES';
